var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-setting',{attrs:{"ClickMethods":_vm.operator_group_add}})}
var staticRenderFns = []

export { render, staticRenderFns }